export default [
  {
    "location": "",
    "icon": "my-generic-blank",
    "iconurl": "https://new-icon-cdn-location/icons/my-generic-blank.svg",
    "contact": {
      "phone": "(02) 9144 2637",
      "email": "gregory.lodge@det.nsw.edu.au"
    },
    "colour": "-",
    "uri": "https://www.google.com/?test=hello",
    "modifiedDateTime": "26:55.1",
    "audience": [
      ""
    ],
    "year_group": [

    ],
    "description": "This terminal server is for performing administration and support activities from home by authorised school staff.",
    "id": "751309999991",
    "createdDateTime": "11:58.9",
    "tags": [
      "My applications",
      "parentapp"
    ],
    "title": "AAA  Test Link"
  },
  {
    "location": "-",
    "icon": "my-linkedin-training",
    "iconurl": "https://new-icon-cdn-location/icons/my-linkedin-training.svg",
    "contact": {
      "phone": "1300 32 32 32",
      "email": ""
    },
    "colour": "-",
    "uri": "https://www.linkedin.com/checkpoint/enterprise/login/74950778?application=learning&authModeName=sso.det.nsw.edu.au",
    "modifiedDateTime": "43789.63332",
    "audience": [
      "SCHOOL.STUDENT",
      "DET.CONTRACTOR",
      "DET.GUEST",
      "DET.GUEST_BROWSE",
      "SCHOOL.CASUALNONTEACHER",
      "SCHOOL.CASUALTEACHER",
      "SCHOOL.NONTEACHER",
      "SCHOOL.PRACTICE",
      "SCHOOL.PRINCIPAL",
      "SCHOOL.PRINCIPAL.DEPUTY.HS",
      "SCHOOL.PRINCIPAL.DEPUTY.PS",
      "SCHOOL.SUBEXECUTIVE",
      "SCHOOL.TEACHER",
      "SCHOOL.TEACHER.APPLICANT.APPOINTED",
      "SCHOOL.STAFF.FORMER",
      "SCHOOL.STAFF.LEAVE",
      "SCHOOL.APPLICANT.PRACTICUM"
    ],
    "year_group": [

    ],
    "description": "LinkedIn Learning is an online library of training videos and courses. This link allows staff to access all content on LinkedIn Learning.",
    "id": "23308889999999",
    "createdDateTime": "43356.66825",
    "tags": [
      "Senior",
      "Junior Primary : Learning",
      "Senior Primary : Learning",
      "High : Learning",
      "My training",
      "parentapp"
    ],
    "title": "LinkedIn Learning"
  },
  {
    "icon": "sentral-icon",
    "iconurl": "https://new-icon-cdn-location/icons/sentral-icon.svg",
    "uri": "https://parents-dev.sentral.com.au/nrrvYEzDcpddZQxw5",
    "id": "sentral-parentapp",
    "NewValue": "",
    "modifiedDateTime": "2022-10-20T04:53:27Z",
    "audience": [
      ""
    ],
    "createdDateTime": "2022-10-20T04:53:27Z",
    "tags": [
      "parentapp"
    ],
    "year_group": [

    ],
    "title": "Sentral"
  }
]
